export const channel = new BroadcastChannel('app')